"use client";
import { jsx as r } from "react/jsx-runtime";
import * as o from "@radix-ui/react-avatar";
import { forwardRef as e, isValidElement as v } from "react";
import { Text as d } from "../Text/Text.mjs";
const c = e((a, t) => /* @__PURE__ */ r(o.Root, { "data-slot": "avatar", ...a, ref: t }));
c.displayName = "AvatarRoot";
const p = e((a, t) => /* @__PURE__ */ r(o.Image, { "data-slot": "avatar-image", ...a, ref: t }));
p.displayName = "AvatarImage";
const f = e(
  ({ children: a, fontSize: t = "sm", fontWeight: l = "semibold", fontFamily: m = "inter", ...s }, i) => /* @__PURE__ */ r(o.Fallback, { "data-slot": "avatar-fallback", ...s, ref: i, children: /* @__PURE__ */ r(d, { asChild: !0, fontSize: t, fontWeight: l, fontFamily: m, children: v(a) ? a : /* @__PURE__ */ r("span", { children: a }) }) })
);
f.displayName = "AvatarFallback";
export {
  f as AvatarFallback,
  p as AvatarImage,
  c as AvatarRoot
};
